import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken, ok } from '../../utils/response';
import { errorResponse, okResponse, okResponseList, notFoundResponse } from '../../utils/response';
import { Token, UserCode, EmployeeId, EmployeeCode, Company } from '../../utils/users';
import { IsEnglish } from '../../utils/language';
import { encryption } from '../../utils/encryption';

export function getMaterialResourceCode(date) {
    let url = 'materialResource/getMaterialResourceCode?' + objectToQueryString({
        userCode: encryption(UserCode()),
        company: encryption(Company()),
        date: date,
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponseList(JSON.parse(response.result));
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getAllMaterialResource() {
    let url = 'materialResource/getAllMaterialResource?' + objectToQueryString({
        userCode: encryption(UserCode()),
        employeeCode: encryption(EmployeeCode()),
        company: encryption(Company()),
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse(JSON.parse(response.result));
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getMaterialResourceByTimesheetId(timesheetId) {
    let url = 'materialResource/getMaterialResourceByTimesheetId?' + objectToQueryString({
        userCode: encryption(UserCode()),
        timesheetId: encryption(timesheetId),
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse(JSON.parse(response.result));
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getAllCombos(date) {
    let url = 'materialResource/getAllCombos?' + objectToQueryString({
        userCode: encryption(UserCode()),
        company: encryption(Company()),
        employeeCode: encryption(EmployeeCode()),
        employeeId: encryption(EmployeeId()),
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse(JSON.parse(response.result));
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function saveMaterial(materialResourceId, materialResourceCodeId, date, quantity, abcProjectCode, abcActivityCode, projectCode, activityCode, taskCode, timesheetId) {
    const body = JSON.stringify({
        userCodeCrypt: encryption(UserCode()),
        companyCrypt: encryption(Company()),
        employeeCodeCrypt: encryption(EmployeeCode()),
        companyCrypt: encryption(Company()),
        materialResourceIdCrypt: encryption(materialResourceId),
        materialResourceCodeIdCrypt: encryption(materialResourceCodeId),
        timesheetIdCrypt: timesheetId > 0 ? encryption(timesheetId) : null,
        date: date,
        quantity: quantity,
        abcProjectCode: abcProjectCode === '' ? null : abcProjectCode,
        abcActivityCode: abcActivityCode === '' ? null : parseInt(abcActivityCode),
        projectCode: projectCode === '' ? null : projectCode,
        activityCode: activityCode === '' ? null : activityCode,
        taskCode: taskCode === '' ? null : taskCode,
        token: Token()
    });
    return fetch('materialResource/save', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: body
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function tasksMaterial(activityPId) {
    let url = 'materialResource/tasks?' + objectToQueryString({
        company: Company(),
        userCode: UserCode(),
        activityPId: activityPId,
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let tasks = response.tasks;

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortTasks(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.taskEn.toLowerCase() : a.taskFr.toLowerCase()
        const nameB = IsEnglish() ? b.taskEn.toLowerCase() : b.taskFr.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortTasksByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.taskCode
        const nameB = b.taskCode
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function deleteMaterial(materialResourceId) {
    const body = JSON.stringify({
        userCodeCrypt: encryption(UserCode()),
        materialResourceIdCrypt: encryption(materialResourceId),
        token: Token()
    });

    return fetch('materialResource/deleteMaterial', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: body
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}